module.exports = __webpack_public_path__ + "img/logo-company.fb03fc21.png";